import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: auto;
  background: #fff;
  min-height: 85vh;
  .history-header,
  .history-content {
    width: 90%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      flex-basis: 10%;
    }
  }
  .history-header {
    font-weight: 700;
  }
  .history-content {
    border-bottom: 1px solid rgb(235 235 235 / 1);
  }
`;
